import { Month, NewsByMonth, NewsYearMonth } from "@/@types";
import { MonthResponse, NewsResponse, NewsYearMonthResponse } from "../../news/models/NewsYearMonthResponse";

export function mapNewsYearMonth(response: NewsYearMonthResponse): NewsYearMonth {
    return {
        year: response.year,
        months: response.months.map((monthResponse: MonthResponse): Month => ({
            month: monthResponse.month,
            news: monthResponse.news.map((newsResponse: NewsResponse): NewsByMonth => ({
                id: newsResponse.id,
                title: newsResponse.title,
                slug: newsResponse.slug,
                categoryName: newsResponse.category_name,
                categorySlug: newsResponse.category_slug,
                date: newsResponse.date,
            })),
        })),
    };
}